import React from "react";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import FormInput from "../../../../../components/Universal/FormInput.component";
import { Formik } from "formik";
import CustomBill from "../../../../../components/Universal/CustomBill.component";
import VendorPaymentValidation from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/MaterialAndResources/VendorPaymentValidation.component";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import "../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/MaterialAndResources.style.css";
import AcademicUniversalTable from "../../../../../components/Universal/Tables/AcademicUniversalTable.component";
import UniversalTable from "../../../../../components/Universal/Tables/UniversalTable.component";

const Body = ({
  labEquipment,
  labTableHeaders,
  labHistoryData,
  columns,
  confirmedByOptions,
  paymentModes,
}) => {
  const [isReceiptOpen, setIsReceiptOpen] = React.useState(false);
  const [checkedItems, setCheckedItems] = React.useState({});
  const [selectedData, setSelectedData] = React.useState([]);
  const [submittedValues, setSubmittedValues] = React.useState(null);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showHistory, setShowHistory] = React.useState(false);

  // tax state (editable)
  const [taxPercent, setTaxPercent] = React.useState(10);

  const handleSelectAll = () => {
    const allSelected = Object.keys(checkedItems).length === labEquipment.length;
    if (allSelected) {
      setCheckedItems({});
      setSelectedData([]);
    } else {
      const newChecked = {};
      const newSelected = [];
      labEquipment.forEach((item) => {
        newChecked[item.itemCode] = true;
        // clone so we can edit `amount`
        newSelected.push({ ...item });
      });
      setCheckedItems(newChecked);
      setSelectedData(newSelected);
    }
  };

  const handleSingleCheck = (itemCode, item) => {
    const updated = { ...checkedItems };
    const isChecked = !!updated[itemCode];

    if (isChecked) {
      delete updated[itemCode];
      setSelectedData((prev) => prev.filter((d) => d.itemCode !== itemCode));
    } else {
      updated[itemCode] = true;
      setSelectedData((prev) => [...prev, { ...item }]);
    }

    setCheckedItems(updated);
  };

  // update amount in selectedData
  const handleAmountChange = (itemCode, newAmount) => {
    setSelectedData((prev) =>
      prev.map((item) =>
        item.itemCode === itemCode ? { ...item, amount: Number(newAmount) || 0 } : item
      )
    );
  };

  // dynamic subtotal, tax and total
  const subtotal = React.useMemo(() => {
    return selectedData.reduce((acc, item) => acc + (Number(item?.amount) || 0), 0);
  }, [selectedData]);

  const taxAmount = React.useMemo(() => (subtotal * taxPercent) / 100, [subtotal, taxPercent]);
  const netTotal = React.useMemo(() => subtotal + taxAmount, [subtotal, taxAmount]);

  // ✅ History section
  if (showHistory)
    return (
      <section className="TransportCostHistorySection">
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={selectedData} vendorInfo={submittedValues} />
          )}
        </ScrollableModal>
        <Helmet>
          <title>All payments history</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="All payments history, cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Helmet>
        <PageHeader title={"All payments history"} />
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All laboratory equipments payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowHistory(false)}
                  className="actionBtn"
                >
                  Go to laboratory equipment
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={labHistoryData}
              maxBodyHeight="340px"
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount: <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts: <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount: <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );

  // ✅ Main section
  return (
    <section className="TransportCostSection">
      <ScrollableModal
        isOpen={isReceiptOpen}
        onClose={() => setIsReceiptOpen(!isReceiptOpen)}
      >
        {isReceiptOpen && (
          <CustomBill data={selectedData} vendorInfo={submittedValues} />
        )}
      </ScrollableModal>
      <Helmet>
        <title>Laboratory equipment</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="Laboratory equipment,cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Laboratory equipment"} />
      <div className="MaterialAndResourceContaienr">
        <div className="left">
          <AcademicUniversalTable
            title="List of all Laboratory equipments needed"
            headers={labTableHeaders}
            data={labEquipment}
            showCheckbox={true}
            checkedItems={checkedItems}
            onSelectAll={handleSelectAll}
            onRowSelect={handleSingleCheck}
          />
        </div>
        <div className="right">
          <div className="content-header">
            <h3>Confirmation of Payment</h3>
            <button
              onClick={() => setShowHistory(true)}
              className="blueActionBtnLight"
            >
              All Payments History
            </button>
          </div>

          {showSuccess ? (
            <div className="billSuccess">
              <h2>You have confirm payment successfully</h2>
              <p>Receipt ID: 23456789012</p>
              <h4 onClick={() => setIsReceiptOpen(true)}>
                Receipt <BsBoxArrowRight />
              </h4>
              <button
                onClick={() => setShowSuccess(false)}
                className="actionBtn"
              >
                Okay
              </button>
            </div>
          ) : (
            selectedData.length > 0 && (
              <>
                <div className="bill-table-container">
                  <table className="bill-table">
                    <thead>
                      <tr>
                        <th>Items({selectedData.length})</th>
                        <th>Order Size</th>
                        <th>Alloted by</th>
                        <th>Amount (INR)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedData.map((item) => (
                        <tr key={item.itemCode}>
                          <td>{item?.item}</td>
                          <td>{item?.orderSize}</td>
                          <td className="reporter">{item.reporter}</td>
                          <td>
                            <span className="totalAmount">
                              ₹{" "}
                              <input
                                type="number"
                                value={item.amount}
                                onChange={(e) =>
                                  handleAmountChange(item.itemCode, e.target.value)
                                }
                                style={{
                                  outline: "none",
                                  border: "none",
                                  backgroundColor: "transparent",
                                  width: "80px",
                                }}
                              />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="totalContainer">
                  <div className="subSection">
                    <div className="subTotal">
                      <span>Sub Total:</span>
                      <span>₹ {subtotal}</span>
                    </div>
                    <div className="taxes">
                      <span>Other tax (GST, SGST, CGST) in %</span>
                      <input
                        type="number"
                        value={taxPercent}
                        onChange={(e) => setTaxPercent(Number(e.target.value) || 0)}
                        style={{
                          outline: "none",
                          border: "none",
                          backgroundColor: "transparent",
                          width: "40px",
                          marginInline: "0.5rem",
                        }}
                      />
                      <span>₹ {taxAmount}</span>
                    </div>
                  </div>
                  <div className="netTotal">
                    <span>Total:</span>
                    <span>₹ {netTotal}</span>
                  </div>
                </div>
                <div className="formContaienr">
                  <Formik
                    initialValues={{
                      vendorName: "",
                      vendorContact: "",
                      paidAmount: "",
                      confirmedBy: "",
                      paymentMode: "",
                    }}
                    validationSchema={VendorPaymentValidation}
                    onSubmit={(values) => {
                      console.log("Form Submitted:", values);
                      setSubmittedValues(values);
                      setShowSuccess(true);
                    }}
                  >
                    {({
                      setFieldValue,
                      handleSubmit,
                      touched,
                      errors,
                      setTouched,
                    }) => (
                      <form
                        onSubmit={handleSubmit}
                        className="vendorPaymentForm"
                      >
                        <div className="vendorPaymentFormInputs">
                          <FormInput
                            label="Vendor name"
                            type="text"
                            name="vendorName"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor name"
                            setFieldValue={(e) =>
                              setFieldValue("vendorName", e.target.value)
                            }
                          />

                          <FormInput
                            label="Vendor contact"
                            type="text"
                            name="vendorContact"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter vendor contact number"
                            setFieldValue={(e) =>
                              setFieldValue("vendorContact", e.target.value)
                            }
                          />

                          <FormInput
                            label="Paid amount (INR)"
                            type="number"
                            name="paidAmount"
                            touched={touched}
                            errors={errors}
                            placeholder="Enter paid amount"
                            setFieldValue={(e) =>
                              setFieldValue("paidAmount", e.target.value)
                            }
                          />

                          <DropDownInput
                            name="confirmedBy"
                            label="Confirmed by"
                            placeholder="Choose confirmed by"
                            suggestionList={confirmedByOptions}
                            setFieldValue={(val) =>
                              setFieldValue("confirmedBy", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />

                          <DropDownInput
                            name="paymentMode"
                            label="Payment mode"
                            placeholder="Choose payment mode"
                            suggestionList={paymentModes}
                            setFieldValue={(val) =>
                              setFieldValue("paymentMode", val)
                            }
                            touched={touched}
                            errors={errors}
                            setTouched={(name, isTouched) =>
                              setTouched({ [name]: isTouched })
                            }
                          />
                        </div>

                        <button
                          type="submit"
                          className="confirmPaymentBtn actionBtn"
                        >
                          Confirm payment
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Body;
